var render = function render(){var _vm=this,_c=_vm._self._c;return _c('footer',{staticClass:"footer"},[_c('div',{staticClass:"container-fluid"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-12"},[_vm._v(" "+_vm._s(new Date().getFullYear() - 1)+" - "+_vm._s(new Date().getFullYear())+" © Mceasy. ")])])])])
}
var staticRenderFns = []

export { render, staticRenderFns }